module.exports = __webpack_public_path__ + "assets/images/bigbox-savetime-optimized.jpg";